<template>
    <div>
        <v-dialog
            :value="isOpen"
            max-width="500px"
            transition="slide-y-transition"
            eager
            @keydown.esc="onClose"
            @click:outside="onClose"
        >
            <v-card>
                <v-card-title>
                    <h1 class="text-subtitle-1">
                        Edycja roboczogodziny
                    </h1>
                </v-card-title>

                <v-card-text class="text-center">
                    <v-text-field
                        v-model="manHourCost"
                        label="Koszt roboczogodziny"
                        outlined
                        dense
                        :error-messages="manHourCostErrors"
                        required
                        suffix="(zł)"
                    />
                </v-card-text>

                <v-divider />

                <v-card-actions>
                    <v-btn
                        color="error"
                        text
                        data-sentry-label="Anuluj"
                        :disabled="actionLoading"
                        @click="onClose()"
                    >
                        Anuluj
                    </v-btn>
                    <v-spacer />
                    <v-btn
                        color="success"
                        text
                        data-sentry-label="Zapisz"
                        :loading="actionLoading"
                        @click="onSave"
                    >
                        Zapisz
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { errorHandler } from '@/utils/errorHandler'
import { required } from 'vuelidate/lib/validators'
import priceFormatter from '@/mixins/priceFormatter'
import { twoDigitsAfterDecimalWithComma } from '@/utils/customValidators'


export default {
    name: 'ManHourCostDialog',
    mixins: [ priceFormatter ],
    props: {
        isOpen: {
            type: Boolean
        },
        machineProcessCostData: {
            type: Object,
            default: null
        },
    },
    data() {
        return {
            manHourCost: null,
            machineProcessCost: {
                manHourCost: null
            },
            actionLoading: false
        }
    },
    validations: {
        manHourCost: {
            required,
            twoDigitsAfterDecimalWithComma
        }
    },
    computed: {
        manHourCostErrors() {
            const errors = []

            if (!this.$v.manHourCost.$dirty) return errors
            !this.$v.manHourCost.required && errors.push('Proszę podać koszt.')
            !this.$v.manHourCost.twoDigitsAfterDecimalWithComma && errors.push('Niepoprawny format.')

            return errors
        },
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.machineProcessCost = JSON.parse(JSON.stringify(this.machineProcessCostData))
                this.manHourCost = JSON.parse(JSON.stringify(this.formatPrice(this.machineProcessCost.manHourCost)))
            }
        },
    },
    methods: {
        onSave() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            this.actionLoading = true
            this.machineProcessCost.manHourCost = this.unformatPrice(this.manHourCost)
            this.$store.dispatch('configurations/updateMachineProcessCost', this.machineProcessCost)
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading = false
                    this.onClose()
                })
        },
        onClose() {
            setTimeout(() => {
                this.machineProcessCost = {
                    manHourCost: null
                },
                this.$v.$reset()
            }, 500)

            this.$emit('on-close')
        }
    }
}
</script>

